import React from 'react';

interface VersionDisplayProps {
    version?: string;
}

export const VersionDisplay: React.FC<VersionDisplayProps> = ({ version = process.env.REACT_APP_VERSION || '1.0.1' }) => {
    return (
        <div style={{
            position: 'fixed',
            bottom: '8px',
            right: '8px',
            fontSize: '12px',
            color: '#666',
            opacity: 0.8
        }}>
            v {version}
        </div>
    );
};